import { render } from "./serviceCategories.vue?vue&type=template&id=7a879b7b"
import script from "./serviceCategories.vue?vue&type=script&lang=js"
export * from "./serviceCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__